module.exports = __webpack_public_path__ + "static/media/dongle_2.20a69657.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dongle_2.png
// module id = 2138
// module chunks = 0